import { render, staticRenderFns } from "./addPrivilegeGroup.vue?vue&type=template&id=2d72979e&scoped=true"
import script from "./addPrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./addPrivilegeGroup.vue?vue&type=script&lang=js"
import style0 from "./addPrivilegeGroup.vue?vue&type=style&index=0&id=2d72979e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72979e",
  null
  
)

export default component.exports